/* Glow Atelier cart guard: locks checkout only while BYO / box lines total < ₹599 and the cart has nothing that
   unlocks them. Unlocked by (1) a non-BYO candle product (type "Candle Combo", or "Candle" tagged candle-set) or
   (2) a Talbeena / Nutri Nuts product (type "Food & Nutrition"; add-on packs only count with their combo, so an
   add-on line alone never unlocks). Stickers / cosmetics / learning do not unlock. Any error unlocks (fail-open). */
(() => {
  let cfg;
  try {
    cfg = JSON.parse(document.getElementById('ga-guard-data').textContent);
  } catch {
    return;
  }
  const SEL = '.cart-page__summary .btn--xl, [data-cart-confirm] [data-flexy-type="buynow"], [data-cart-drawer] [data-flexy-type="buynow"]';
  const MIN = Number(cfg.min) || 59900;
  const byo = cfg.byo || {};
  const sets = cfg.sets || {};
  try {
    Object.assign(byo, JSON.parse(sessionStorage.getItem('ga_byo') || '{}'));
    Object.assign(sets, JSON.parse(sessionStorage.getItem('ga_sets') || '{}'));
  } catch {}
  let locked = false;
  let left = 0;
  let total = 0;
  let seq = 0;
  const money = (p) => {
    const r = Math.round(p) / 100;
    return `₹${r.toLocaleString('en-IN', { minimumFractionDigits: r % 1 ? 2 : 0, maximumFractionDigits: 2 })}`;
  };

  // Tags are not in /cart.js: seeded from Liquid (byo, sets), else read once from /products/<handle>.js
  async function meta(handle) {
    if (!(handle in byo) || !(handle in sets)) {
      try {
        const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
        const p = res.ok ? await res.json() : null;
        const tags = p && Array.isArray(p.tags) ? p.tags : [];
        byo[handle] = tags.includes('byo-candle');
        sets[handle] = tags.includes('candle-set');
        try {
          sessionStorage.setItem('ga_byo', JSON.stringify(byo));
          sessionStorage.setItem('ga_sets', JSON.stringify(sets));
        } catch {}
      } catch {
        return { byo: false, set: false };
      }
    }
    return { byo: !!byo[handle], set: !!sets[handle] };
  }
  const isAddonLine = (it) => !!(it.properties && (it.properties['Linked combo'] || it.properties._addon === '1'));

  function unlock() {
    locked = false;
    document.querySelectorAll('.ga-guard-locked').forEach((b) => {
      b.classList.remove('ga-guard-locked');
      if (b.dataset.gaWas !== 'd') b.disabled = false;
      if (b.dataset.gaWasAria) b.setAttribute('aria-disabled', b.dataset.gaWasAria);
      else b.removeAttribute('aria-disabled');
      delete b.dataset.gaWas;
      delete b.dataset.gaWasAria;
    });
    document.querySelectorAll('.ga-guard-msg').forEach((m) => m.remove());
  }

  function apply() {
    if (!locked) return;
    const text = cfg.text.split('[amount]').join(money(left));
    const pct = Math.min(1, total / MIN).toFixed(3);
    document.querySelectorAll(SEL).forEach((b) => {
      if (!b.classList.contains('ga-guard-locked')) {
        b.dataset.gaWas = b.disabled ? 'd' : '';
        b.dataset.gaWasAria = b.getAttribute('aria-disabled') || '';
        b.classList.add('ga-guard-locked');
        b.disabled = true;
        b.setAttribute('aria-disabled', 'true');
      }
      let m = b.previousElementSibling;
      if (!m || !m.classList.contains('ga-guard-msg')) {
        m = document.createElement('div');
        m.className = 'ga-guard-msg';
        m.setAttribute('role', 'status');
        m.innerHTML = '<p></p><span class="ga-guard-bar"><i></i></span><a></a>';
        m.querySelector('a').href = cfg.url;
        m.querySelector('a').textContent = cfg.link;
        b.before(m);
      }
      const p = m.querySelector('p');
      if (p.textContent !== text) p.textContent = text;
      const i = m.querySelector('i');
      if (i.style.transform !== `scaleX(${pct})`) i.style.transform = `scaleX(${pct})`;
    });
  }

  async function evaluate(cart, mine) {
    if (!cart || !Array.isArray(cart.items)) throw new Error('cart');
    // Box line = has _box_id, or is a byo-candle product (the old builder handle only matters for carts made before v2)
    const box = [];
    let unlocks = false;
    for (const it of cart.items) {
      const hasId = !!(it.properties && it.properties._box_id);
      const m = it.handle ? await meta(it.handle) : { byo: false, set: false };
      if (hasId || it.handle === cfg.builder || m.byo) {
        box.push(it);
        continue;
      }
      const type = String(it.product_type || '').trim().toLowerCase();
      if (type === 'candle combo' || (type === 'candle' && m.set)) unlocks = true; // (1) Festive, Grand, Scentelle Set…
      else if (type === 'food & nutrition' && !isAddonLine(it)) unlocks = true; // (2) Talbeena / Nutri Nuts combo
    }
    if (mine !== seq) return;
    if (!box.length || unlocks) return unlock();
    total = box.reduce((s, it) => s + (Number(it.final_line_price) || 0), 0);
    if (total >= MIN) return unlock();
    left = MIN - total;
    locked = true;
    apply();
  }

  async function check(cart) {
    const mine = ++seq;
    try {
      if (!cart) {
        const res = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        if (!res.ok) throw new Error('cart');
        cart = await res.json();
      }
      await evaluate(cart, mine);
    } catch {
      if (mine === seq) unlock();
    }
  }

  let t;
  const later = () => {
    clearTimeout(t);
    t = setTimeout(() => check(), 150);
  };

  window.addEventListener(
    'click',
    (e) => {
      try {
        if (locked && e.target.closest && e.target.closest(SEL)) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      } catch {}
    },
    true
  );
  document.addEventListener('cart:updated', later);
  document.addEventListener('cart:confirm', later);
  // Back / Forward from the bfcache, or a tab coming back: the cart may have changed elsewhere
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) later();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') later();
  });

  const start = () => {
    check(cfg.cart);
    try {
      const mo = new MutationObserver((recs) => {
        const ours = (n) => n.nodeType !== 1 || n.classList.contains('ga-guard-msg') || !!n.closest('.ga-guard-msg');
        if (recs.every((r) => ours(r.target) || [...r.addedNodes, ...r.removedNodes].every(ours))) return;
        if (recs.every((r) => r.addedNodes.length + r.removedNodes.length === 0)) return;
        later();
      });
      document.querySelectorAll('[data-cart-page], [data-cart-confirm], [data-cart-drawer]').forEach((el) => mo.observe(el, { childList: true, subtree: true }));
    } catch {}
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
